import { Clickable, Col, Icon, Row, SegmentControl, Shoutout, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ShoutoutsCol = ({ closeModal, user, data, forwardOption, onDelete }) => {
  const [option, setOption] = useState(1),
    [sortedData, setSortedData] = useState([]),
    { t } = useTranslation(),
    { isMobile } = useSelector((state) => state.appState),
    options = [t('common.trending'), t('common.latest')];

  useEffect(() => {
    if (forwardOption) {
      forwardOption(option);

      setSortedData(data);

      return;
    }

    setSortedData(
      [...data].sort((a, b) =>
        option === 0
          ? Object.values(b.reactionCounts || {}).reduce((acc, v) => acc + v, 0) -
            Object.values(a.reactionCounts || {}).reduce((acc, v) => acc + v, 0)
          : new Date(b.createdAt) - new Date(a.createdAt)
      )
    );
  }, [option, data]);

  return (
    <Col wid="100%" pad="0 0 16px">
      <Row between center ht={isMobile ? '44px' : '88px'}>
        <Text h2>{t('common.shoutouts')}</Text>

        <Row center noFlexs>
          {!isMobile && (
            <SegmentControl
              small
              options={options}
              selectedIdx={option}
              handleSelect={setOption}
              textStyle={{ b2: true, marg: '9px 24px' }}
            />
          )}

          {closeModal && (
            <Clickable marg="0 0 0 21px" onClick={closeModal}>
              <Icon type="close" col={theme.GREY_50} dimensions={14} />
            </Clickable>
          )}
        </Row>
      </Row>

      {isMobile && (
        <SegmentControl
          small
          options={options}
          selectedIdx={option}
          handleSelect={setOption}
          textStyle={{ b2: true, marg: '9px 24px' }}
          marg="0 0 16px 0"
        />
      )}

      {sortedData.map((x, i) => (
        <Col marg="0 0 12px" wid="100%" key={i}>
          <Shoutout item={x} user={user} wide onDelete={onDelete} />
        </Col>
      ))}
    </Col>
  );
};

export default ShoutoutsCol;
